import ImportQuestions from "pages/dashboard/shared/ImportQuestions";

const AdminImportQuestion = () => {
  return <ImportQuestions />;
};

export default AdminImportQuestion;
